import React, { useState } from "react";
import FAQ_icon from "../assets/FAQ_icon.png";

export default function FAQ({ questions }) {
  const [openIndex, setOpenIndex] = useState();
  const [showAll, setShowAll] = useState(false);

  const displayedFaqs = showAll ? questions : questions.slice(0, 7);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="bg-black text-white py-16 sm:py-9">
      <div className=" mx-auto sm:px-6 px-24 md:px-8 lg:px-16 xl:px-20">
        {/* Main Layout */}
        <div className="flex lg:flex-row md:gap-20 lg:gap-30 sm:gap-12 sm:flex-col sm:items-center items-start">
          {/* LEFT SIDE */}
          <div className="flex flex-col w-full sm:w-[90%] lg:w-[40%] sm:text-center sm:items-center">
            <div className="w-[72px] h-[72px] sm:w-16 sm:h-16 bg-[#111315] rounded-full flex items-center justify-center mb-6 sm:mb-8">
              <span className="text-2xl">
                <img src={FAQ_icon} alt="FAQ Icon" />
              </span>
            </div>

            <h1 className="font-[Norwester] text-[45px] xl:text-[44px] lg:text-[40px] md:text-[36px] sm:text-[24px]  font-[400]  uppercase mb-4 leading-tight max-w-xl sm:mx-0">
              Frequently Asked <br /> Questions
            </h1>

            <p className="font-[Inter] text-[#C4C7CC] text-[18px] sm:text-sm  md:text-sm leading-tight max-w-xl sm:mx-0">
              {questions.question}
            </p>
          </div>

          {/* RIGHT SIDE */}
          <div className="relative lg:w-[100%] w-full sm:items-center">
            {/* FAQ Container */}
            <div className="relative">
              <div className="space-y-4">
                {displayedFaqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`bg-[#111315] rounded-xl overflow-hidden border ${
                      openIndex === index
                        ? "border-[#FFF528]"
                        : "border-[#181A1D]"
                    }`}
                  >
                    <div
                      className="flex items-center justify-between w-full min-h-[64px] lg:min-h-[56px] sm:min-h-[50px] p-4 cursor-pointer hover:bg-[#111315] transition-colors"
                      onClick={() => toggleQuestion(index)}
                    >
                      <h3 className="text-[17px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[13px] font-medium pr-4 flex-1 break-words leading-snug">
                        {faq.question}
                      </h3>
                      <div className="relative z-20 w-10 h-10 lg:w-8 lg:h-8 sm:w-7 sm:h-7 flex items-center justify-center text-xl lg:text-lg sm:text-base flex-shrink-0 text-white ml-3">
                        {openIndex === index ? "−" : "+"}
                      </div>
                    </div>

                    <div
                      className={`overflow-hidden transition-all duration-300 ease-in-out ${
                        openIndex === index
                          ? "max-h-96 opacity-100"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      <div>
                        <div className="px-4">
                          <div className="border-t border-[#40444D]" />
                        </div>
                        <div className="p-4 text-[#FFFFFF] text-[16px] xl:text-[15px] lg:text-[14px] md:text-[13px] sm:text-[13px] leading-relaxed">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Fade Overlay (on questions) */}
              {!showAll && (
                <div className="absolute bottom-0 left-0 right-0 h-20 md:h-32 bg-gradient-to-t from-black to-transparent pointer-events-none"></div>
              )}
            </div>

            {/* View more/less Button */}
            {questions.length > 7 && (
              <div className="flex justify-center mt-8">
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="bg-white text-black px-6 sm:px-8 py-3 rounded-md font-bold uppercase text-sm sm:text-xs hover:bg-gray-200 transition-all"
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
